import * as ActionTypes from '../../actions/allActions'

const userAffiliateInit = { selectedAffiliateID: "" }
const userAffiliate = (state = userAffiliateInit, action) => {
	switch(action.type){
		case ActionTypes.SIGNIN_SUCCESS:
		case ActionTypes.CHECKTOKEN_SUCCESS:
		case ActionTypes.ACCOUNT_PROFILE_SUCCESS:
			let affiliate = action.data.data.attributes.affiliates.data[0]
			if (affiliate !== undefined) {
				return { ...state, selectedAffiliateID: affiliate.id }
			}
			return state
		case ActionTypes.USERAFFILIATE_METACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.LOGOUT:
			return userAffiliateInit
		default:
			return state
	}
}

export default userAffiliate



// WEBPACK FOOTER //
// ./src/reducers/metadata/userAffiliate.js